import {
  SETTING_INVENTORY_PAGE_REQUEST,
  SETTING_INVENTORY_UPDATE_SETTING,
  SETTING_INVENTORY_SET_ROLES,
  SETTING_INVENTORY_SET_PERMISSIONS,
} from './constant';

import type { InventorySettingsForm } from '../../../types/settings/InventorySetting';
import type { Permission, Role } from '../../../types/roles/Role';
import type {
  InventorySettingSaveAction,
  InventorySettingSetPermissionsAction,
  InventorySettingSetRolesAction,
} from './types';

export function settingInventoryPageRequest() {
  return {
    type: SETTING_INVENTORY_PAGE_REQUEST,
    payload: {},
  };
}

export function settingInventoryUpdateSettings(
  inventorySettingForm: InventorySettingsForm,
  additional: {
    advancedTransferEnabled?: boolean;
    advancedPOEnabled?: boolean;
  }
): InventorySettingSaveAction {
  return {
    type: SETTING_INVENTORY_UPDATE_SETTING,
    payload: {
      inventorySettingForm,
      additional,
    },
  };
}

export function settingInventorySetRoles(
  roles: Role[]
): InventorySettingSetRolesAction {
  return {
    type: SETTING_INVENTORY_SET_ROLES,
    payload: {
      roles,
    },
  };
}

export function settingInventorySetPermissions(
  permissions: Permission[]
): InventorySettingSetPermissionsAction {
  return {
    type: SETTING_INVENTORY_SET_PERMISSIONS,
    payload: {
      permissions,
    },
  };
}
